import React from 'react';
import { Building2, Workflow, Users } from 'lucide-react';
import { Reveal, SectionHeading } from '../SectionHeading';

const cols = [
  { icon: Building2, title: 'Workplaces', points: ['Workforce deployment', 'On-ground operations', 'Hub management'], desc: 'Physical operations staffed, supervised and run with discipline.' },
  { icon: Workflow, title: 'Workflows', points: ['Process optimization', 'AI-enabled execution', 'Productivity management'], desc: 'Processes engineered for throughput, quality and visibility.' },
  { icon: Users, title: 'Workforce', points: ['Hiring', 'Training', 'Performance management'], desc: 'People sourced, skilled and managed against clear outcomes.' },
];

export const IntelligentSolutions = () => (
  <section data-testid="intelligent-solutions" className="py-20 md:py-32 bg-[#F8FAFC]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        label="Intelligent Solutions"
        title="Intelligent Solutions for Workplaces, Workflows & Workforce"
        subtitle="Three layers of execution — combined into one accountable delivery system."
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {cols.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12}
            className="group relative p-8 bg-white border border-slate-200 rounded-xl overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
            <div className="absolute top-0 left-0 h-1 w-0 bg-[#0066CC] group-hover:w-full transition-all duration-500" />
            <div className="w-14 h-14 rounded-lg bg-[#0A192F] flex items-center justify-center mb-6">
              <c.icon className="w-6 h-6 text-[#4DA3FF]" />
            </div>
            <h3 className="text-xl font-semibold text-[#0A192F] font-heading">{c.title}</h3>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed">{c.desc}</p>
            <ul className="mt-6 space-y-2.5">
              {c.points.map((p) => (
                <li key={p} className="flex items-center gap-2.5 text-sm text-slate-700">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#0066CC]" /> {p}
                </li>
              ))}
            </ul>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
